import React, { useEffect } from 'react'
import { FormSelectField } from '@/components/Form/FormField'
import { PlatformTypeDto, PlatformTypeId } from 'api/Trading-Accounts/Types/PlatformTypeDto'
import { ServerType } from 'api/Trading-Accounts/Types/ServerType'
import { isEmpty } from 'lodash'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchPlatformTypesAction } from 'store/trading-accounts/trading-accounts.actions'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'

interface SourceServerFormProps {
  platformServers: ServerType[]
  setPlatformServers: (value: React.SetStateAction<ServerType[]>) => void

  platform?: PlatformTypeDto
  setPlatformType: (value: React.SetStateAction<PlatformTypeDto | undefined>) => void

  server?: ServerType
  setServer: (value: React.SetStateAction<ServerType | undefined>) => void
}

export const SourceServerForm = (props: SourceServerFormProps) => {
  const { platformServers, server, platform } = props
  const { setPlatformServers, setServer, setPlatformType } = props

  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)
  const platformTypes = useAppSelector((state) => state.tradingAccounts.platformTypes)
  const dispatch = useAppDispatch()

  const [loading, setIsLoading] = React.useState(false)

  useEffect(() => {
    if (isEmpty(platformTypes)) dispatch(fetchPlatformTypesAction(tradingAccountsApiClient))
  }, [])

  const fetchServerActionAndSetDefault = async (platformId: PlatformTypeId) => {
    try {
      setIsLoading(true)
      setServer(undefined)
      setPlatformServers([])
      const resp = await tradingAccountsApiClient.getTradingAccountServerType(platformId)
      setPlatformServers(resp)
      if (resp.length) {
        setServer(resp[0])
      }
    } catch (e: unknown) {
      console.error(e)
      setServer(undefined)
      setPlatformServers([])
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (platform && !loading) {
      fetchServerActionAndSetDefault(platform.id)
    }
  }, [platform])

  return (
    <div className='max-w-xs pb-2'>
      <FormSelectField
        value={platform ? platform.id : ''}
        options={platformTypes}
        onChange={(value) => {
          const selectedPlatform = platformTypes?.find((pl) => pl.id === Number(value))
          if (selectedPlatform) {
            setPlatformType(selectedPlatform)
            setServer(undefined)
          }
        }}
        label='Platform'
      />
      <FormSelectField
        disabled={loading}
        value={server ? server.id : ''}
        options={platformServers}
        onChange={(value) => {
          const serverById = platformServers?.find((srv) => srv.id === value)
          if (serverById) setServer(serverById)
        }}
        label='Server'
      />
    </div>
  )
}
